<template>
  <div>
    <div class="flex progress_box mar_top_20">
      <div class="progress_one">
        <div class="flex Flexalign FlexBetween study_progress">
          <div class="study_progress_text">当前课程学习进度</div>
          <!-- <div class="study_progress_value">{{(courseLearnedInfo.alreadyStudyChapterNum/courseLearnedInfo.chapterNum*100).toFixed(2)}}%</div> -->
          <div class="study_progress_value">
            {{ courseLearnedInfo.watchedTotalProgress?.toFixed(2) }}%
          </div>
        </div>
        <div class="progress mar_top_10">
          <el-image class="sort_green_icon" :src="iconPath('sort_green_icon.png')"
            :style="getLeftPosition(courseLearnedInfo.watchedTotalProgress)"></el-image>
          <div class="progress_active" :style="getActiveWidth(courseLearnedInfo.watchedTotalProgress)"></div>
        </div>
      </div>
      <div class="progress_one mar_left_20">
        <div class="flex Flexalign FlexBetween study_progress">
          <div class="study_progress_text">课程平均学习进度</div>
          <div class="study_progress_value">
            {{ allCourseLearnedInfo.watchedTotalProgress?.toFixed(2) }}%
          </div>
        </div>
        <div class="progress mar_top_10">
          <el-image class="sort_green_icon" :src="iconPath('sort_green_icon.png')"
            :style="getLeftPosition(allCourseLearnedInfo.watchedTotalProgress)"></el-image>
          <div class="progress_active" :style="getActiveWidth(allCourseLearnedInfo.watchedTotalProgress)"></div>
        </div>
      </div>
    </div>
    <div class="progress_list mar_top_10" v-if="progressList?.length">
      <div class="list_top flex FlexBetween Flexalign">
        <!-- <div class="list_chapter">章节</div> -->
        <div class="list_name">名称</div>
        <div class="list_time">视频时长</div>
        <div class="list_progress">视频观看进度</div>
        <!-- <div class="test_progress">测试进度</div> -->
      </div>
      <div v-for="(item, index) in progressList" :key="index">
        <div class="list_top flex FlexBetween Flexalign list_one"
        :class="[index % 2 == 1 ? 'active_bg' : '']" v-if="!$Tools.empty(item.phaseInfo)">
        <!-- <div class="list_chapter">{{ item.chapter }}</div> -->
        <div class="list_name toverflow">{{ item.chatperInfo?.chapterName }}-{{item.phaseInfo?.phaseName}}</div>
        <div class="list_time">{{ $Tools.convertMinutesToCountdown(item.phaseInfo?.chapterResource?.videoDuration) }}
        </div>
        <div class="list_progress flex flexcolumn Flexalign">
          <el-progress type="circle" :color="'rgba(0, 212, 152, 1)'" :stroke-width="20" :show-text="false"
            :percentage="item.watchedProgress" />
        </div>
        <!-- <div class="test_progress flex flexcolumn Flexalign" v-if="item.examStatus == 1">
          <el-image class="sign_in_icon" :src="iconPath('sign_in_icon.png')"></el-image>
        </div>
        <div class="test_progress" v-else>未完成</div> -->
      </div>
      </div>
    </div>
    <div v-else>
      <moe-empty url="moe_empty_bg_img.png" emptyText="暂无学习章节"></moe-empty>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GjkcH5StudyProgress",

  data() {
    return {
      progressList: [],
      courseLearnedInfo: {},
      allCourseLearnedInfo: {},
      courseChapterList: [],
    };
  },
  props: {
    courseDetail: {},
  },
  computed: {
    ...mapState({
      courseScheme: (state) => state.learning.courseScheme,
      courseRound: (state) => state.learning.courseRound
    }),
  },

  mounted() {
    this.getMycourseListProgress();
    this.getAllMycourseListProgress();
    this.getCourseChapter();
  },

  methods: {
    getActiveWidth(value) {
      return {
        width: value + "%",
      };
    },
    getLeftPosition(value) {
      return {
        left: `calc(${value + "%"} - 5px)`,
      };
    },
    // 查询当前课程学习进度
    getMycourseListProgress() {
      this.$Api.learning
        .getMycourseListProgress({ courseIds: this.courseDetail.courseId })
        .then((res) => {
          this.courseLearnedInfo = res.data.data[0];
        })
        .catch(() => { });
    },
    // 获取课程章节列表
    getCourseChapter() {
      this.$Api.course
        .getCourseChapterNew({ courseId: this.courseDetail.courseId,schemeId: this.courseScheme,roundId:this.courseRound })
        .then((res) => {
          let courseChapterList = res.data.data;
          this.courseChapterList = this.$Tree.handleTree(
            courseChapterList,
            "chapterId",
            "parentId"
          );
          // 统计时长
          this.courseChapterList = this.getAllChildren(this.courseChapterList);
          setTimeout(() => {
            this.getChapterProgress();
          }, 500);
        })
        .catch((err) => {
          // this.$Dialog.toast(err.data.message, { type: "error" });
          console.log(err);
        });
    },
    // 做递归统计
    getAllChildren(arr) {
      // 递归计算单个节点的总时长
      const calc = (node) => {
        let total = node.chapterResource.videoDuration || 0; // 基础值
        let totalChapter = 0; // 统计章节数
        if (node.children?.length) {
          // 有子节点时递归
          total += node.children.reduce((sum, child) => sum + calc(child).total, 0);
          totalChapter += node.children.length;
        }
        return {
          total,
          totalChapter,
        };
      };

      // 处理第一层并返回新数组
      return arr.map((item) => ({
        ...item, // 保留原有属性
        totalSecond: calc(item).total, // 添加统计结果
        totalChapter: calc(item).totalChapter,
        isExpanded: true, // 第一层默认展开状态
      }));
    },
    // 查询所有课程学习进度
    getAllMycourseListProgress() {
      this.$Api.learning
        .getAllMycourseListProgress()
        .then((res) => {
          this.allCourseLearnedInfo = res.data.data;
        })
        .catch(() => { });
    },
    // 查询课程下所有章节学习进度
    getChapterProgress() {
      let listQuery = {
        courseId: this.courseDetail.courseId,
        chapterId: "",
        studyStatus: "",
      };
      this.$Api.learning
        .getChapterProgress(listQuery)
        .then((res) => {
          this.progressList = res.data.data;
          this.progressList.forEach(item => {
            item.chatperInfo = this.findChapterById(this.courseChapterList, item.chapterId);
            // 获取阶段信息
            if(!this.$Tools.empty(item.chatperInfo)){
              let phaseInfo = item.chatperInfo.phaseVoList.filter(sitem=>sitem.id == item.schemeChapterPhaseId)[0];
              item.phaseInfo = phaseInfo;
            }
          })
        })
        .catch(() => { });
    },
    // 迭代查找chapterID数据
    findChapterById(arr, targetId) {
      for (const item of arr) {
        if (item.chapterId === targetId) {
          return item; // 找到匹配项，直接返回
        }
        if (item.children && item.children.length > 0) {
          const found = this.findChapterById(item.children, targetId); // 递归查找子级
          if (found) return found; // 子级中找到，直接返回
        }
      }
      return null; // 遍历完未找到
    },
  },
};
</script>

<style lang="scss" scoped>
.progress_box {
  .progress_one {
    width: 280px;
    height: 88px;
    background: rgba(238, 250, 248, 0.6);
    border-radius: 10px;
    padding: 15px 20px;
    box-sizing: border-box;

    .study_progress {
      .study_progress_text {
        color: #333333;
      }

      .study_progress_value {
        font-weight: bold;
        font-size: 30px;
        color: #13d6aa;
      }
    }

    .progress {
      width: 240px;
      height: 8px;
      background: #eef0f4;
      border-radius: 4px;
      position: relative;

      .progress_active {
        position: absolute;
        top: 0;
        left: 0;
        height: 8px;
        background: #13d6aa;
        border-radius: 4px;
      }

      .sort_green_icon {
        width: 10px;
        height: 10px;
        position: absolute;
        top: -10px;
      }
    }
  }
}

.progress_list {
  .list_top {
    text-align: center;
    color: #333333;
    // font-weight: 600;
    height: 45px;
    line-height: 45px;

    .list_chapter {
      width: 15%;
    }

    .list_name {
      width: 35%;
      text-align: start;
    }

    .list_time {
      width: 20%;
    }

    .list_progress {
      width: 15%;

      :deep(.el-progress-circle) {
        width: 22px !important;
        height: 22px !important;
      }
    }

    .test_progress {
      width: 15%;

      .sign_in_icon {
        width: 22px;
        height: 22px;
      }
    }
  }

  .list_one {
    color: #999999;
  }

  .active_bg {
    background: #f8f9fa;
  }
}
</style>
